import React from "react";

function SendIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_9_12)">
        <path
          d="M10 20.5L13 16M22 3L2 11L20.5 19L22 3ZM15.5 9.5L9 14L9.859 20.012C9.937 20.558 10.075 20.549 10.165 20.009L11 15L15.5 9.5Z"
          stroke="#667085"
          stroke-width="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_9_12">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SendIcon;
